<template>
  <div class="page new-ticket">
    <header>
      <div @click="back" tabindex="0" @keypress.space="back" class="back-btn"><i class="fa fa-fw fa-chevron-left"></i></div>
      <div class="view-title">{{ 'register' | lang }}</div>
    </header>
    <div>
      <!-- <p @click="withCSC = !withCSC">
        <i class="fa fa-fw" :class="{ 'fa-check-square-o': withCSC, 'fa-square-o': !withCSC }"></i>Possiedo una tessera
      </p> -->
      <div class="reg-form">
        <!-- <div v-if="withCSC">
          <div class="floating-label">
            <input v-model="mediaSerialNumber" placeholder=" " type="text" :class="{ invalid: !mediaSerialNumber }" />
            <label>{{ 'CSCserialNr' | lang }}</label>
          </div>
          <div class="floating-label">
            <input v-model="mediaUnicity" placeholder=" " type="text" :class="{ invalid: !mediaUnicity }" />
            <label>{{ 'CSCunicity' | lang }}</label>
          </div>
        </div> -->
        <div>
          <div class="floating-label">
            <input v-model="name" placeholder=" " type="text" :class="{ invalid: !name }" />
            <label>{{ 'FirstName' | lang }}</label>
          </div>
          <div class="floating-label">
            <input v-model="surname" placeholder=" " type="text" :class="{ invalid: !surname }" />
            <label>{{ 'LastName' | lang }}</label>
          </div>
          <div class="floating-label">
            <input v-model="birthdate" placeholder=" " type="date" :class="{ invalid: !birthdate }" />
            <label>{{ 'BirthDate' | lang }}</label>
          </div>
          <div class="floating-label">
            <input v-model="birthplace" placeholder=" " type="text" :class="{ invalid: !birthplace }" />
            <label>{{ 'BirthPlace' | lang }}</label>
          </div>
          <div class="floating-label">
            <input v-model="fiscalCode" placeholder=" " type="text" :class="{ invalid: !fiscalCode || fiscalCode.length > 16 }" />
            <label>{{ 'FiscalCode' | lang }}</label>
          </div>
        </div>
      </div>

      <div>
        <p @click="condizioniVendita = !condizioniVendita">
          <i class="fa fa-fw" :class="{ 'fa-check-square-o': condizioniVendita, 'fa-square-o': !condizioniVendita }"></i>{{ 'CguText1' | lang }} <a @click.stop :href="manifest.cguUrl" target="_blank">{{ 'CguText2' | lang }}</a>
        </p>
      </div>
      <div>
        <p @click="condizioniVendita2 = !condizioniVendita2">
          <i class="fa fa-fw" :class="{ 'fa-check-square-o': condizioniVendita2, 'fa-square-o': !condizioniVendita2 }"></i>{{ 'CgvText1' | lang }} <a @click.stop :href="manifest.cgvUrl" target="_blank">{{ 'CgvText2' | lang }}</a>
        </p>
      </div>
      <!-- <div @click="rememberMe = !rememberMe">
        <i class="fa fa-fw" :class="{ 'fa-check-square-o': rememberMe, 'fa-square-o': !rememberMe }"></i>Ricordami
      </div> -->
      <div v-if="status">
        <div v-if="status === 'waiting'">
          <i class="fa fa-fw fa-refresh fa-spin"></i>{{ 'pleaseWait' | lang }}
        </div>
        <div v-else-if="status === 'error'" class="text-red">
          <i class="fa fa-fw fa-exclamation-triangle"></i>{{ (statusDetails || 'errorOccured') | lang }}
        </div>
        <div v-else-if="status === 'success'" class="text-green">
          <i class="fa fa-fw fa-check"></i>{{ 'RegistrationDone' | lang }}
        </div>
      </div>
    </div>
    <footer>
      <button class="full-width" @click="register" :disabled="invalidForm || isWaiting">{{ 'register' | lang }}</button>
    </footer>
  </div>
</template>

<script>
import page from '@/mixins/routeControl'
import UserServices from '@/mixins/services/userServices'

export default {
  name: 'Registration2',
  mixins: [ page, UserServices ],
  data () {
    return {
      withCSC: false,
      name: '',
      surname: '',
      birthdate: '',
      birthplace: '',
      fiscalCode: '',
      status: '',
      statusDetails: null,
      mediaSerialNumber: '',
      mediaUnicity: '',
      condizioniVendita: false,
      condizioniVendita2: false
    }
  },
  computed: {
    email () {
      return this.$route.query.email
    },
    token () {
      return this.$route.query.token
    },
    security () {
      return this.$route.query.security
    },
    invalidForm () {
      if (!(this.condizioniVendita && this.condizioniVendita2)) {
        return true
      }
      if (!this.withCSC) {
        return false
      } else {
        return !this.mediaSerialNumber || !this.mediaUnicity
      }
    },
    isWaiting () {
      return this.status === 'waiting'
    }
  },
  methods: {
    register () {
      this.status = 'waiting'
      let promise = null
      /* if (this.withCSC) {
        promise = this._doUserRegistrationWithMedia({
          FirstName: this.name,
          LastName: this.surname,
          BirthDate: this.birthdate,
          BirthPlace: this.birthplace,
          Email: this.email,
          MediaSerialNumber: this.mediaSerialNumber,
          MediaUnicity: this.mediaUnicity,
          FiscalCode: this.fiscalCode,
          security: this.security,
          registrationToken: this.token
        })
      } else { */
      promise = this._doUserRegistrationWithoutMedia({
        FirstName: this.name,
        LastName: this.surname,
        BirthDate: this.birthdate,
        Email: this.email,
        BirthPlace: this.birthplace,
        FiscalCode: this.fiscalCode,
        security: this.security,
        registrationToken: this.token
      })
      // }
      promise.then(data => {
        this.status = 'success'
        console.log(data)
        this.internalBus.$emit('notify:success', {
          text: this.dictValue('RegistrationDone'),
          key: this.notifierKey
        })
        // this.back()
        this.goTo('/', true, true)
      }).catch(response => {
        this.status = 'error'
        // this.statusDetails = 'error'
        let msg = this.dictValue('error') + (response.status === 418 ? '[VAD]' : '')
        console.log(response)
        if (typeof response.body === 'string') {
          msg = response.body
        } else {
          for (let k in response.body) {
            msg = response.body[k][0]
          }
        }
        this.internalBus.$emit('notify:error', {
          text: msg,
          key: this.notifierKey,
          timeout: 3000
        })
      })
    }
  },
  beforeDestroy () {},
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      this.name = 'Vincenzo'
      this.surname = 'Minolfi'
      this.birthdate = '1987-05-27'
      this.birthplace = 'Breno'
      this.fiscalCode = 'MNLVCN87E27B149Y'
      this.status = ''
      this.statusDetails = null
      this.mediaSerialNumber = '564673478567768'
      this.mediaUnicity = '45'
      this.condizioniVendita = true
      this.condizioniVendita2 = true
    }
    while (!this.user) {
      this.isAutoLogging = true
      this.user = await this._doAnonymousLogin()
      this.isAutoLogging = false
    }
  },
  watch: {
    fiscalCode () {
      if (this.fiscalCode && this.fiscalCode.length > 16) {
        this.fiscalCode = this.fiscalCode.substring(0, 16)
      }
      this.fiscalCode=this.fiscalCode.toUpperCase()
    }
  }
}
</script>

<style>

#app.mobile .reg-form > * {
  grid-template-columns: repeat(1, 100%);
}

#app.desktop.small .reg-form > * {
  grid-template-columns: repeat(2, 50%);
}

.reg-form > * {
  display: grid;
  column-gap: .1rem;
  grid-template-columns: repeat(4, 25%);
  padding-top: .1rem;
}

</style>
